function n(n,r){(null==r||r>n.length)&&(r=n.length);for(var e=0,t=new Array(r);e<r;e++)t[e]=n[e];return t}export{n as default};
//# sourceMappingURL=arrayLikeToArray.js.map
